import React from "react";

// export
export function VerticalSpacer({ height }) {
  return <div style={{ height: height }} />;
}
